import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { BaseModalComponent, ModalButton } from '@app/shared/components/modals/modal-base';
import { ModalController, NavController } from '@ionic/angular';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-success-modal',
  standalone: true,
  templateUrl: './modal-success.component.html',
  styleUrls: ['./modal-success.component.scss'],
  imports: [CommonModule, IonicModule],
})
export class SuccessModalComponent extends BaseModalComponent {
  @Input() message = '';
  @Input() destructive = false;

  @Input() override buttons: ModalButton[] = [
    {
      text: 'Okay',
      fill: 'outline',
      cssClass: 'tertiaryBtn',
    },
  ];

  constructor(protected override modalCtrl: ModalController, protected override navCtrl: NavController) {
    super(modalCtrl, navCtrl);
  }
}
